import { useNavigate } from 'react-router-dom';
import '../../css/home/SectionHeader.css';
import { useLang } from '../../i18n';

export default function SectionHeader({ title, to = '/sports' }) {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div className="sechead">
      <h2>{title}</h2>
      <button className="sechead-link" onClick={() => navigate(to)}>{t('common.viewAll')}</button>
    </div>
  );
}
